import { gql } from '@apollo/client';

export const GET_UW_BY_PERIOD_ID = gql`
  query UW_SERVICE_GetUwResultByPeriodId($groupId: String!, $periodId: String!) {
    getUwResultByPeriodId(groupId: $groupId, periodId: $periodId) {
      guidelines {
        productLineId
        rules
      }
      result {
        productLineId
        eligibilityStatus
        products {
          id
          name
          original {
            rates {
              id
              key
              displayKey
              value
            }
            browsingCriteria
          }
          final {
            rates {
              id
              key
              displayKey
              value
            }
            browsingCriteria
          }
        }
        uwValidationResult {
          status
          name
          message
        }
      }
    }
  }
`;

export const GET_GUIDELINES = gql`
  query UW_SERVICE_getGuidelines($guidelineDTOs: [GuidelineDTO!]!) {
    getGuidelines(guidelineDTOs: $guidelineDTOs) {
      productLineId
      rules
    }
  }
`;
